import React, { useState, useEffect } from "react";
import Custom_Carosal from "re_redesigned_componnents/carosal/Custom_Carosal";
import { IconArrow } from "../icon/index";
import "./tabwrap.scss"
import { useMediaQuery } from '@mui/material'
function TabWrap({ tab = [], tabValue = [] ,seeMoreRoute=()=>{console.log("no functions")}}) {
  const [activeTab, setActiveTab] = useState(0); 
  const [carouselData, setCarouselData] = useState(tabValue[0] || []);
  const [direction, setDirection] = useState(null);
  const isLargeScreen = useMediaQuery('(min-width:768px)'); 
  useEffect(() => {
    console.log("one punchman",tabValue[activeTab].length)
    setCarouselData(tabValue[activeTab] || []);
  }, [activeTab, tabValue]);

  const btnLeftStyle={
    position:"absolute",
    rotate: "180deg",
    top:"50%",
    left:"-1rem",
    zIndex: "100",
    cursor: "pointer",
  }
  
  const btnRightStyle={
    position:"absolute",
    top:"50%",
    right:"-1rem",
    zIndex: "100",
    cursor: "pointer",
  }
  return (
    <div>
      <div style={{ display: "flex", cursor: "pointer", gap: "1rem" }}>
        {tab.map((ele, index) => (
          <div
            key={index}
            style={{ display: "flex", flexDirection: "column", cursor: "pointer" }}
          >
            <div
           
              style={{
                paddingBlock: ".8rem",
                fontSize: "16px",
                fontWeight: "600",
                color: activeTab === index ? "#750AC4" : "#7F7F7F",
              }}
              onClick={() => setActiveTab(index)}
            >
              {ele}
            </div>
            <div
              style={{
                backgroundColor: (activeTab === index && isLargeScreen) ? "#750AC4" : "transparent",
                height: "4px",
                width: "100%",
              }}
            ></div>
          </div>
        ))}
      </div>

      <div className="tabWrap" style={isLargeScreen?{ paddingTop: "20px" ,position:"relative"}:{ position:"relative"}}>
       {isLargeScreen && <IconArrow  style={btnLeftStyle} onClick={()=>setDirection("left")}/>}
        <Custom_Carosal item={carouselData} btnClick={direction} setDirection ={setDirection} hide={true}/>
        {isLargeScreen && <IconArrow style={btnRightStyle} onClick={()=>setDirection("right")}/>}
        <p onClick={(
       )=>{seeMoreRoute()}} style={{ paddingTop: ".8rem" ,margin:"0px",textDecoration:"underline",color:"blue",cursor:"pointer",display:"flex",justifyContent:"flex-end",alignItems:"center",paddingInline:"1rem"}}>See All</p>
      </div>
    </div>
  );
}

export default TabWrap;
